module.exports = __webpack_public_path__ + "static/media/payment-plat1.34542f5b.png";